import React from 'react'
import { Spinner } from 'reactstrap';

const LoadingScreen = () => {
    return <div style={{
        width: '100vw',
        height: '100vh',
        position: 'absolute',
        backgroundColor: '#00000040',
        zIndex: '100',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        top: '0px'
    }}>
        <Spinner color="primary" />
    </div>
}

export default LoadingScreen;